import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import React from 'react';

const CloseSmileySelectorButton = ({
    setShowSmileySelector
}) => {
    const { ref, focused } = useFocusable({
        focusKey: "closesSileySelector",
        isFocusBoundary: true,
        trackChildren: true,
        autoRestoreFocus: true,
        onEnterRelease: () => { setShowSmileySelector(false) }
    });
    return (
        <FocusContext.Provider value={"closesSileySelector"}>
            <i ref={ref} style={{ position: "absolute", right: "10px", top: "15px", cursor: "pointer", color: "white", border: focused ? "2px solid #007FFF" : "2px solid transparent", padding: "5px" }} className='fa fa-x' onClick={() => { setShowSmileySelector(false) }} />
        </FocusContext.Provider>
    );
}

export default CloseSmileySelectorButton;
